import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

function getSeverityDot(severity) {
  const s = (severity || '').toLowerCase();
  if (s.includes('critical')) return 'bg-[hsl(0,84%,60%)]';
  if (s.includes('warning') || s.includes('high')) return 'bg-[hsl(24,94%,56%)]';
  if (s.includes('medium')) return 'bg-[hsl(45,93%,58%)]';
  return 'bg-[hsl(45,93%,58%)]';
}

export function TopRiskDrivers({ drivers = [] }) {
  const maxContribution = Math.max(...drivers.map(d => d.contribution || 0), 1);

  return (
    <Card className="bg-card border-border/80" data-testid="top-risk-drivers-card">
      <CardHeader className="flex flex-row items-start justify-between pb-4">
        <CardTitle className="text-base font-semibold">Top Risk Drivers</CardTitle>
        <Link to="/signals" className="text-xs text-[hsl(188,100%,55%)] hover:underline">
          View Full Report
        </Link>
      </CardHeader>
      <CardContent className="space-y-6">
        {drivers.length === 0 && <p className="text-sm text-muted-foreground">No active risk drivers</p>}
        {drivers.map((driver, i) => {
          const pct = Math.min((driver.contribution / maxContribution) * 100, 100);
          return (
            <div key={i} className="space-y-2.5">
              {/* Driver name with colored dot */}
              <div className="flex items-center gap-2">
                <span className={cn('w-3 h-3 rounded-full flex-shrink-0', getSeverityDot(driver.severity))} />
                <span className="text-sm font-medium">{driver.name}</span>
              </div>
              {/* Gradient progress bar + score */}
              <div className="flex items-center gap-3">
                <div className="flex-1 h-2 rounded-full bg-muted/40 overflow-hidden relative">
                  {/* Multi-color gradient bar */}
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${pct}%`,
                      background: 'linear-gradient(90deg, hsl(142, 72%, 45%) 0%, hsl(45, 93%, 58%) 35%, hsl(24, 94%, 56%) 65%, hsl(0, 84%, 60%) 100%)'
                    }}
                  />
                </div>
                <span className="text-sm font-semibold tabular-nums text-foreground min-w-[40px] text-right">
                  +{driver.contribution}
                </span>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
